import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
    title: {
        fontSize: "20px !important",
        fontWeight: "bold !important",
        fontFamily: "'KantarBrownWeb-Light', sans-serif",
        color: "#333",
        marginBottom: "10px",
        marginLeft: "50px !important",
        marginTop: "20px !important",
    },
    errorMessage: {
        fontSize: "16px !important",
        fontFamily: "'KantarBrownWeb-Light', sans-serif",
        color: "black",
        fontWeight: "bold",
        marginTop: "25px !important",
        marginLeft: "50px !important",
    },
    homeButton: {
        marginTop: '10px',
        padding: '10px 20px',
        fontSize: '14px',
        color: 'white',
        backgroundColor: 'black',
        fontFamily: "'KantarBrownWeb-Light', sans-serif",
        marginLeft: "50px !important",
    }
});